import { render, staticRenderFns } from "./CompareView.vue?vue&type=template&id=ed79793c&scoped=true&"
import script from "./CompareView.vue?vue&type=script&lang=ts&"
export * from "./CompareView.vue?vue&type=script&lang=ts&"
import style0 from "./CompareView.vue?vue&type=style&index=0&id=ed79793c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed79793c",
  null
  
)

export default component.exports